import React, { useState } from 'react';
import styled from 'styled-components';
import { cssColorValue, cssSpacing } from '@spotify-internal/encore-web';
import { ANIMATION_DURATION, Slide, SlideContainer, } from './Slide/Slide';
import { ColorSetWrapper } from '../../../ui/Colors/Colors';
const CarouselContainer = styled.div `
  color: ${cssColorValue('textBase')};
  background-color: ${cssColorValue('backgroundBase')};
  transition: background-color ${ANIMATION_DURATION};
  padding-block: ${cssSpacing('looser-2')};
`;
export function getPreviousSlideIndex(slideIndex, numSlides, direction) {
    return direction === 'next'
        ? Math.max(slideIndex - 1, 0)
        : Math.min(slideIndex + 1, numSlides - 1);
}
export const Carousel = (props) => {
    var _a, _b;
    const { slides, locale } = props;
    const [slideIndex, setSlideIndex] = useState(0);
    const [direction, setDirection] = useState('');
    const currentSlide = slides[slideIndex];
    const previousSlideIndex = getPreviousSlideIndex(slideIndex, slides.length, direction);
    const handlePrev = () => {
        setDirection('previous');
        setSlideIndex(Math.max(slideIndex - 1, 0));
    };
    const handleNext = () => {
        setDirection('next');
        setSlideIndex(Math.min(slideIndex + 1, slides.length - 1));
    };
    const formattedColors = {
        backgroundColor: ((_a = currentSlide.colors) === null || _a === void 0 ? void 0 : _a.backgroundColor) || currentSlide.backgroundColor,
        textColor: ((_b = currentSlide.colors) === null || _b === void 0 ? void 0 : _b.textColor) || '#000000',
    };
    return (React.createElement(ColorSetWrapper, { colors: formattedColors },
        React.createElement(CarouselContainer, null,
            React.createElement(SlideContainer, { handlePrev: handlePrev, handleNext: handleNext, index: slideIndex + 1, slideCount: slides.length, locale: locale }, slides.map((slide, i) => {
                let className = '';
                if (i === slideIndex) {
                    className = 'active';
                }
                else if (i === previousSlideIndex) {
                    className = 'previous';
                }
                return (React.createElement(Slide, { key: i, ...slide, className: className, direction: direction }));
            })))));
};
